import type { JSX } from 'react';

/**
 * State is never carried by colour alone — every state that has a colour also
 * has one of these plus a written label (CLAUDE.md §7.5).
 *
 * Icons are decorative here: the label beside them is what a screen reader
 * announces, so each one is aria-hidden rather than duplicating that text.
 */
export interface IconProps {
  readonly className?: string;
}

export interface GlyphProps extends IconProps {
  readonly children: JSX.Element;
}

export function Glyph({ className = 'size-4', children }: GlyphProps): JSX.Element {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      focusable="false"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.75"
      viewBox="0 0 24 24"
    >
      {children}
    </svg>
  );
}
